import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Megaphone, ArrowRight } from "lucide-react";
import OgloszeniaList from "@/components/OgloszeniaList";

export default function OgloszeniaTeaser() {
    return (
        <section id="ogloszenia" className="py-20 lg:py-28 bg-white" data-testid="ogloszenia-teaser">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5 }}
                    className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-12"
                >
                    <div className="max-w-2xl">
                        <p className="text-[#D4A537] text-[10px] uppercase tracking-[0.35em] font-semibold mb-3">
                            Sąsiedzka tablica ogłoszeń
                        </p>
                        <h2 className="font-serif text-4xl md:text-5xl text-[#092E22] flex items-center gap-3 leading-tight">
                            <Megaphone className="text-[#D4A537]" size={36} /> Ogłoszenia mieszkańców
                        </h2>
                        <p className="text-gray-600 mt-4 leading-relaxed">
                            Coś sprzedasz, kupisz, oddasz albo polecisz usługę sąsiadowi?
                            Tablica jest dla Was — każde zgłoszenie jest moderowane i automatycznie archiwizowane po 30 dniach.
                        </p>
                    </div>
                    <Link
                        to="/ogloszenia"
                        data-testid="ogloszenia-teaser-cta"
                        className="self-start md:self-end inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#0D4F3C] hover:bg-[#092E22] text-white text-sm font-medium transition-colors"
                    >
                        Zobacz wszystkie <ArrowRight size={16} />
                    </Link>
                </motion.div>

                <OgloszeniaList limit={3} showAddButton={false} />
            </div>
        </section>
    );
}
